module.exports = __webpack_public_path__ + "static/media/share.20785f7c.svg";